export default "__VITE_ASSET__DGXv17Es__"